/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHighlightColumns = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 2H2v20h10V4h6v4h2V2H3zm1 2h6v16H4V4zm9.623 13.77.078 1.2.09 1.399-.237.631-.475 1.267-.274.733h2.527l.961-1.187 1.257-.621 1.077-.533.434-.905 3.635-7.587L18.943 10l-4.753 6.942-.566.828zm3.7.981-1.396-.806 3.62-5.287.545.315-2.769 5.778z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHighlightColumns as HighlightColumns };
